var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#196a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "197b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#197b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#406421",
    fillRule: "evenodd",
    d: "M13.619 7.999c0-1.472-1.173-2.667-2.62-2.667-1.445 0-2.618 1.195-2.618 2.667S9.554 10.665 11 10.665 13.619 9.471 13.619 8m-2.62 1.6c.868 0 1.572-.955 1.572-2.134S11.867 5.332 11 5.332s-1.572.955-1.572 2.133c0 1.179.704 2.134 1.572 2.134",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5B852",
    d: "M11 8.532c.29 0 .524-.478.524-1.067S11.289 6.398 11 6.398s-.524.478-.524 1.067c0 .59.235 1.067.524 1.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4596D2",
    fillRule: "evenodd",
    d: "M0 0h7.333v16H0zm14.667 0H22v16h-7.333z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "196a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagGt = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagGt);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";